// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-3f72453e]{margin:10px 0}.box span[data-v-3f72453e]{padding-right:30px}", ""]);
// Exports
module.exports = exports;
